/*
 * Vajihi Labs - Email Signature Builder
 * Local file download for the Apply tab's "Download signature" action.
 * Pure browser APIs — no Office.js dependency, works in standalone preview
 * too. Produces a real, documented .html file with the same resolved
 * markup Insert/Copy use; it depends on whatever hosted image URLs the
 * signature already references (nothing is bundled or made
 * self-contained by this step).
 */

export interface DownloadResult {
  ok: boolean;
  message: string;
}

export function downloadSignatureHtml(html: string, filename = "signature.html"): DownloadResult {
  try {
    const documented = `<!-- Vajihi Labs signature export. Paste this HTML into Outlook's own\n     signature settings, or into another mail client that accepts HTML\n     signatures. Any logo/social images referenced here load from their\n     configured hosted URLs, not from this file. -->\n${html}`;
    const blob = new Blob([documented], { type: "text/html" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // Object URLs backing a completed download can be revoked once the
    // browser has had a moment to start the save.
    setTimeout(() => URL.revokeObjectURL(url), 4000);
    return { ok: true, message: "Downloaded — open it to confirm, or attach it as needed." };
  } catch {
    return { ok: false, message: "Couldn't start the download in this view. Try Copy HTML code instead." };
  }
}
